import { useState } from 'react';

export const useUploadState = () => {
  const [uploadSuccess, setUploadSuccess] = useState<boolean>(false);

  const handleUploadComplete = (onFileReload: () => void) => {
    setUploadSuccess(true);
    onFileReload(); // Reload files after upload
  };

  return {
    uploadSuccess,
    handleUploadComplete,
    setUploadSuccess
  };
};
